import { useIsIndustryTaxonomyOptedIn } from "app/pages/sales-intelligence/modules/industry/hooks/useIsIndustryTaxonomyOptedIn";

import { IndustryTaxonomyDemoBanner } from "./IndustryTaxonomyDemoBanner";
import { IndustryTaxonomyLaunchBanner } from "./IndustryTaxonomyLaunchBanner";

/**
 * Picks the one industry-taxonomy banner the home page may show. The two address opposite halves of the
 * rollout — announce it to an account that has it, offer a preview to one that does not — so the branch lives
 * here rather than in two independently-gated components that only happen to be complements.
 *
 * Each banner still narrows further on its own (the offer on role and flag, the announcement on dismissal),
 * so either may render nothing.
 */
export const IndustryTaxonomyHomeBanner = () => {
    const isOptedIn = useIsIndustryTaxonomyOptedIn();

    return isOptedIn ? <IndustryTaxonomyLaunchBanner /> : <IndustryTaxonomyDemoBanner />;
};
